'use strict';

var common = require('brand_core/common');
var utils = require('brand_core/utils');

function updatePLPBadges(tile, badges) {
    var badgePrimaryContainer = tile.find('.product-badge-container');
    var badgeSecondaryContainer = tile.find('.plp-label--secondary');
    var badgeTertiary = tile.find('.plp-label--tertiary');

    if (badges.plpBadgePrimaryHtml && badgePrimaryContainer.length > 0) {
        badgePrimaryContainer.html(badges.plpBadgePrimaryHtml);
    }
    if (badges.plpBadgeSecondaryHtml && badgeSecondaryContainer.length > 0) {
        badgeSecondaryContainer.html(badges.plpBadgeSecondaryHtml);
    }
    if (badges.plpBadgeTertiaryHtml && badgeTertiary.length > 0) {
        badgeTertiary.html(badges.plpBadgeTertiaryHtml);
    }
}

/**
 * toggles visibility between image and video for the productTileMixedMedia template
 * for when user selects a swatch that does not correlate to the the custom video target product
 * @param {string} tile PLP grid productTile markup provided by the searchBase.selectVariation selector
 * @param {string} selectedSwatchColorID color code for the returned product data from the swatch AJAX call
 */
function handleCustomProductTileSwatchInteraction(tile, selectedSwatchColorID) {
    let customTileColorID = tile.attr('product-color');

    if (customTileColorID === selectedSwatchColorID) {
        tile.find('.custom-product-tile-mixed-media').removeClass('d-none');
        tile.find('.custom-product-tile-default-image').addClass('d-none');
    } else {
        tile.find('.custom-product-tile-mixed-media').addClass('d-none');
        tile.find('.custom-product-tile-default-image').removeClass('d-none');
    }
}

const selectVariation = function () {
    $(document).on('click', '.product-tile .swatch-item.swatch-circle', function () {
        var swatchcircle = $(this);
        var url = swatchcircle.data('variation-url');
        var PDPUrl = url.replace('Variation', 'Show');
        var quickViewUrl = url.replace('Variation', 'ShowQuickView');
        var tile = swatchcircle.closest('.product-tile');
        var prevSelectedSwatch = tile.find('.selected');
        tile.find('.selected').removeClass('selected');
        swatchcircle.addClass('selected');

        var cgid = $('.category-id').val();

        if (cgid) {
            url = utils.appendParamToURL(url, 'cgid', cgid);
        }

        $.ajax({
            url: url,
            method: 'GET',
            success: function (response) {
                var desktopDefault = response.imagesDefaultHover.desktopDefault;
                var mobileDefault = response.imagesDefaultHover.mobileDefault;
                var desktopHover = response.imagesDefaultHover.desktopHover;
                var mobileHover = response.imagesDefaultHover.mobileHover;
                var selectedColorText = null;

                try {
                    selectedColorText = response.product.variationAttributes
                        .filter(item => item.displayName.toLowerCase() === 'color')[0].values
                        .filter(colorObj => colorObj.selected === true)[0].displayValue;
                } catch (err) {
                    console.error(err); // eslint-disable-line no-console
                }

                common.lazyLoad();
                var isVG = response.isVG;
                var PDPUrlVG = PDPUrl;
                if (isVG && isVG === 'true' && response.urls.product) {
                    PDPUrlVG = response.urls.product;
                }

                tile.find('.selected').removeClass('selected');
                swatchcircle.addClass('selected');
                tile.find('span.swatch').attr('aria-checked', 'false');
                swatchcircle.find('span.swatch').attr('aria-checked', 'true');
                tile.find('.js-image-wrapper').attr('href', PDPUrlVG);

                var prevSelectedSwatchCircle = prevSelectedSwatch.find('.swatch-circle');
                prevSelectedSwatchCircle.attr('aria-label', prevSelectedSwatchCircle.data('aria-label'));
                var newSelectedSwatchCircle = swatchcircle.find('.swatch-circle');
                newSelectedSwatchCircle.attr('aria-label', newSelectedSwatchCircle.data('aria-label-selected'));

                if (!tile.find('.js-image-wrapper').find('picture').length) {
                    tile.find('.js-image-wrapper').find('img').each(function (index, el) {
                        let desktopImage = index === 0 ? desktopDefault : desktopHover;

                        $(el)
                            .attr('src', desktopImage.url)
                            .attr('alt', desktopImage.alt)
                            .attr('title', desktopImage.title);
                    });
                }

                tile.find('.js-image-wrapper').find('picture').each(function (index, el) {
                    let mobileImage = index === 0 ? mobileDefault : mobileHover;
                    let desktopImage = index === 0 ? desktopDefault : desktopHover;

                    $(el).find('source[media="(min-width:992px)"]').attr('srcset', desktopImage.url);
                    $(el).find('source[media="(max-width:991px)"]').attr('srcset', mobileImage.url);
                    $(el).find('img')
                        .attr('src', desktopImage.url)
                        .attr('alt', desktopImage.alt)
                        .attr('title', desktopImage.title);
                });

                if (selectedColorText) {
                    tile.find('.tile-color-name').text(selectedColorText);
                }
                tile.find('.quickview').attr('href', quickViewUrl);
                tile.find('.pdp-link a').attr('href', response.urls.product);

                updatePLPBadges(tile, response.badges);
                // page designer custom product tile component swatch updates
                if (tile && tile.attr('custom-product-tile')) {
                    let selectedSwatchColorID = response.product.variationAttributes
                        .filter(item => item.displayName.toLowerCase() === 'color')[0].values
                        .filter(colorObj => colorObj.selected === true)[0].id;

                    handleCustomProductTileSwatchInteraction(tile, selectedSwatchColorID);
                }
            },
            error: function () {
                tile.find('.selected').removeClass('selected');
                if (prevSelectedSwatch.length > 0) {
                    prevSelectedSwatch.addClass('selected');
                }
            }
        });
    });

    $(document).on('keydown', 'span .swatch.swatch-circle', function (evt) {
        if (evt.which === 13 || evt.which === 32) {
            $(this).trigger('click');
        }
    });
};

module.exports = {
    selectVariation: selectVariation
};
